import { IDeal, IMeal } from '~/types/combo';
import { IProductV4 } from '~/types/product';

export const getProductPriceInList = (product: IProductV4 | IDeal | IMeal): string => {
  return product.is_size && product.sizes.length ? product.sizes[0].price : product.price;
};
